import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useEducation } from '../../context/educationContext';
import Sidebar from '../../components/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';

const Student = () => {
  const { listEnrollments } = useEducation();
  const [students, setStudents] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await listEnrollments({
        start_date: '2025-01-01'
      });
      setStudents(data.results);
    };
    fetchData();
  }, [listEnrollments]);

  return (
    <div>
      <Sidebar />
      <Header />
      <div className="container">
        <Titulo children={<h2>Histórico de Alunos</h2>} />
        <div className="content content-table">
          <table className="student-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Curso</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {students.map((student) => (
                <tr key={student.id}>
                  <td>{student.internal_name}</td>
                  <td>{student.class_education_name}</td>
                  <td>
                    {student.end ? 'Finalizado' : 'Em andamento'}
                  </td>
                  <td>
                    <Link to="/alunos">
                      <FontAwesomeIcon icon={faEye} />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Student;